import { Component, OnInit, OnDestroy } from '@angular/core';
import { DataIoService } from '../../../../services/data-io.service';
import { MenuService } from '../../../../services/menu.service';
import { KeyValuePair } from '../../../../classes/KeyValuePair';
import { TranslationService } from '../../../../services/translation.service';
import { TextdisplayComponent } from '../../../helpers/textdisplay/textdisplay.component';
@Component({
    selector: 'app-menu-showcase',
    templateUrl: './menu-showcase.component.html',
    styleUrls: ['./menu-showcase.component.scss'],
    standalone: false
})
export class MenuShowcaseComponent implements OnInit,OnDestroy {

  _texts:Array<string>;
	get text(){
		return this._texts;
	}
  getTranslator():TranslationService{
    return this.translator;
  }
  constructor(private ioService:DataIoService, private menuService: MenuService, private translator: TranslationService) { 
  	this.parameters=new Array<string>();
  }

  title:string;
  eventHandler(event){
  	if(event == "confirm"){
  		if(this.menuService.hasNextMenuItem()){
  			this.menuService.selectNextMenuItem();
  		}else{
  			this.menuService.hierarchyUp();
  		}
  		return;
  	}
  	if(this.parameters.includes(event)){
  		this.eventHandler('confirm');
  		return;
  	}
  	if(event == "back"){
      if(this.menuService.hasPreviousMenuItem()){
  		  this.menuService.selectPreviousMenuItem();
      }else{
        this.menuService.hierarchyUp();
      }
  		return;
  	}

  }
  get items(){
  	let texts = new Array<KeyValuePair>();
  	for(let item of this._dict){
  		texts.push(item.value);
  	}
  	return texts;
  }
  _dict : Array<KeyValuePair>;
  parameters:Array<string>;
	eventSubscription:any;
	ngOnInit() {
		this.parameters = this.menuService.getCurrentNode().getTemplateParameters();
		this.title = this.menuService.getCurrentNode().getTitle();
    this._dict = this.menuService.getCurrentNode().getDictionary();
    this._texts = this.menuService.getCurrentNode().getTexts();
		this.eventSubscription = this.ioService.inputs.events$.subscribe(
			(event)=>{
				this.eventHandler(event);
			});
	}
	ngOnDestroy(){
		if(this.eventSubscription){
			this.eventSubscription.unsubscribe();
		}
	}

}
